import React, { useState } from 'react';
import { Container, Card, Button, Title, Input } from '../../styles/GlobalStyles';

const PlayerSetup = ({ onStartGame, onBack, translations, language }) => {
  const [playerNames, setPlayerNames] = useState(['', '', '', '']);
  const t = translations[language];

  const handleNameChange = (index, value) => {
    const newNames = [...playerNames];
    newNames[index] = value;
    setPlayerNames(newNames);
  };

  const isValid = playerNames.every(name => name.trim()) &&
    new Set(playerNames.map(name => name.trim().toLowerCase())).size === 4;

  const handleSubmit = (e) => {
    e.preventDefault();
    if (isValid) {
      onStartGame(playerNames.map(name => name.trim()));
    }
  };

  return (
    <Container>
      <Title>{t.enterPlayerNames}</Title>

      <Card>
        <form onSubmit={handleSubmit}>
          {playerNames.map((name, index) => (
            <Input
              key={index}
              placeholder={`${t.player} ${index + 1}`}
              value={name}
              onChange={(e) => handleNameChange(index, e.target.value)}
              maxLength={20}
            />
          ))}

          <Button
            type="submit"
            disabled={!isValid}
            variant={isValid ? 'success' : 'secondary'}
          >
            {t.startGame}
          </Button>
        </form>

        <Button variant="secondary" onClick={onBack}>
          {t.back}
        </Button>

        {playerNames.some(name => name.trim()) && !isValid && (
          <div style={{
            color: '#dc3545',
            fontSize: '14px',
            textAlign: 'center',
            marginTop: '10px'
          }}>
            {playerNames.every(name => name.trim())
              ? 'Alle namen moeten uniek zijn'
              : 'Vul alle namen in'}
          </div>
        )}
      </Card>
    </Container>
  );
};

export default PlayerSetup;
